import React from 'react';

import UserTutorials from 'sections/@Tutorials/UserTutorials';
import { PageWrapper } from 'widgets';

function Tutorials() {
  return (
    <PageWrapper subtitle="APP GUIDES" title="How to use CodeChum">
      <UserTutorials />
    </PageWrapper>
  );
}

export default Tutorials;

export function Head() {
  return (
    <>
      <title>CodeChum | How It Works</title>
      <meta
        content="Whether you're a teacher or a student, we've got you covered! We've prepared some tutorials on how to use CodeChum."
        name="description"
      />
      <meta
        content="https://codechum.com/meta/tutorials.png"
        property="og:image"
      />
    </>
  );
}
